import createError from '../createError';
import type {Params} from '../types';

export function numberValidators(value: number, field: string, params: Params) {
  return {
    number: () => number(value, field),
    lessThan: () => lessThan(value, field, parseInt(params + '')),
    moreThan: () => moreThan(value, field, parseInt(params + '')),
    positive: () => positive(value, field),
    negative: () => negative(value, field),
    integer: () => integer(value, field),
  };
}

const number = (value: number, field: string) => {
  return createError(value, field, 'number', (value: number) => isNaN(value));
};

const lessThan = (value: number, field: string, params: number) => {
  return createError(
    value,
    field,
    'lessThan',
    (value: number) => value >= params,
    params
  );
};

const moreThan = (value: number, field: string, params: number) => {
  return createError(
    value,
    field,
    'moreThan',
    (value: number) => value <= params,
    params
  );
};

const positive = (value: number, field: string) => {
  return createError(value, field, 'positive', (value: number) => value < 0);
};

const negative = (value: number, field: string) => {
  return createError(value, field, 'negative', (value: number) => value >= 0);
};

const integer = (value: number, field: string) => {
  return createError(
    value,
    field,
    'integer',
    (value: number) => !Number.isInteger(value)
  );
};
